(function ()
{
	//Library depencencies
	var ListTask = include('springroll.ListTask'),
		Application = include('springroll.Application'),
		Debug = include('springroll.Debug', false);

	var app = new Application({
		fps: 15,
		name: 'SortingBox',
		state: 'title',
		configPath: 'assets/config/config.json',
		captionsPath: 'assets/config/captions.json',
		manifestsPath: 'assets/config/manifests.json'
	});

	app.once('manifestLoaded', function(taskManager)
	{
		taskManager.addTask(
			new ListTask(
				"transition",
				this.manifests.Transition,
				function (results)
				{
					for (var id in results)
					{
						images[id] = results[id].content;
					}
				}
			)
		);
	});

	// The container client in this version of SpringRoll (0.3) sends a `loadDone` event which has been deprecated.
	// So, to patch this game, we'll also send a loaded event which is the newer equivalent.
	app.on('beforeInit', function() {
		this.container.send('loaded');
	});

	app.once('init', function ()
	{
		var assets = this.config.assets;
		var scaling = this.config.scaling;
		var fla = this.manifests;

		this.transition = new lib.Transition();
		this.states = {
			title: new sid.TitleState({
				next: 'game',
				manifest: assets.title,
				scaling: scaling.title
			}),
			game: new sid.GameState({
				next: 'title',
				previous: 'title',
				manifest: [].concat(
					assets.game,
					fla.Game,
					fla.May
				),
				scaling: scaling.game
			})
		};
		if (DEBUG && Debug)
		{
			this.learning.on('learningEvent', function(data)
			{
				Debug.log(data.event_data);
			});
		}
	});

	//Assign to namespace
	window.app = app;

}());
